import {
  HeroSection,
  ManifestoSection,
  ProductSection,
  PlatformsSection,
  ImaginerSection,
} from '@/sections';

export function HomeRoute() {
  return (
    <main className="relative z-10">
      <HeroSection />
      <ManifestoSection />
      <ProductSection />
      <PlatformsSection />
      <ImaginerSection />
    </main>
  );
}
